import { render, staticRenderFns } from "./passwordNew.vue?vue&type=template&id=f954a34a&scoped=true&"
import script from "./passwordNew.vue?vue&type=script&lang=js&"
export * from "./passwordNew.vue?vue&type=script&lang=js&"
import style0 from "./passwordNew.vue?vue&type=style&index=0&id=f954a34a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f954a34a",
  null
  
)

export default component.exports